/**
 * object-tools
 *
 * Object Tools is a Django convention.
 *
 * Editing and content management links for the object you are viewing.
 * The options for editing are parsed from the server side content
 * or set dynamically.
 *
 * The object-tools directive gets its contents from here.
 */
/* @ngInject */
export function ObjectTools(flux) {
  class _ObjectTools {
    items = [];
    init() {
      flux.onAction("set-object-tools", data => {
        this.items = data || [];
        flux.changed("ObjectTools", data);
      });
    }
  }

  return new _ObjectTools();
}
